module.exports = __webpack_public_path__ + "media/images/icons/icn_014-0b96637037678f06a80c1c5ff931da1b.svg";